import React, { memo, useEffect, useState } from 'react';

const AccessibilityStatement: React.FC = () => (
  <>
    <h2 id="accessibility-modal-title" className="accessibility-modal-title">
      הצהרת נגישות
    </h2>

    <h3>הסדרי נגישות</h3>
    <p>
      קבוצת החינוך אנקורי נוקטת את מירב המאמצים ומשקיעה משאבים רבים על מנת לספק
      לכל לקוחותיה שירות שוויוני, מכובד, נגיש ומקצועי. בהתאם לחוק שוויון זכויות
      לאנשים עם מוגבלויות תשנ"ח-1998 ולתקנות שהותקנו מכוחו, מושקעים מאמצים
      ומשאבים רבים בביצוע התאמות הנגישות הנדרשות שיביאו לכך שאדם בעל מוגבלות יוכל
      לקבל את השירותים הניתנים לכלל הלקוחות, באופן עצמאי ושוויוני.
    </p>

    <h3>מידע על נגישות האתר</h3>
    <p className="accessibility-modal-updated">מעודכן ליום 13/04/2026</p>
    <p>
      אנחנו בקבוצת החינוך אנקורי תמיד שואפים לספק לקהל הרחב הגולש באתר תוכן נגיש
      ככל שניתן, ללא כל קשר לטכנולוגיה בה נבנה האתר. אנחנו פועלים לעדכן ולהטמיע
      את כללי הנגישות ככל שניתן, בהתאם לעקרונות תקן הנגישות. האתר מותאם לדרישות
      הנגישות לרמה 2 (AA) של התקן W.C.A.G 2. הנגישות באתר מותאמת לדפדפנים
      המובילים.
    </p>
    <p>
      האתר מונגש באמצעות חברת UA USER ACCESSIBILITY ותומך בטכנולוגיות המסייעות
      המובילות בתחום.
    </p>
    <p>
      תפריט הנגישות מציע מגוון של אפשרויות. כדי ללמוד עוד על אופן השימוש לחצו על
      F1 במקלדת והוראות השימוש של התוסף תופענה.
    </p>
    <p>
      בשל תנאים שאינם בשליטתנו, ייתכנו מקרים בהם לא נהיה מסוגלים לספק את המידע
      בצורה נגישה, לרבות משום שחלקים מסוימים באתרים טרם הונגשו. אנו נעקוב אחר
      מקרים אלו על מנת שנוכל לספק את הפתרון הטכנולוגי המתאים.
    </p>
    <p>
      מסירת מידע בפורמט נגיש: בהתאם לצורך אנו מעמידים עבור לקוחותינו אפשרות לקבלת
      מידע בפורמטים נגישים. מסירת המידע הינה ללא עלות ומיועדת עבור אנשים עם
      מוגבלות בהתאם לצרכיהם הספציפיים ככל האפשר. לפניות ומידע בנושא נגישות ניתן
      ליצור קשר עם רכז/ת הנגישות של החברה שפרטיה מופיעים בהמשך ההצהרה.
    </p>
    <p>
      יש לציין כי אנו ממשיכים באופן תדיר במאמץ לשפר את נגישות האתר כחלק
      ממחויבותנו לאפשר לכלל האוכלוסייה, כולל אנשים עם מוגבלויות, לגלוש בו בצורה
      הנגישה ביותר. במידה שנתקלת בבעיה או תקלה כלשהי בנושא הנגישות, נשמח להתעדכן
      בכך ואת/ה מוזמנים לפנות בנושא לרכז/ת הנגישות שפרטיו/ה בהמשך ההצהרה, ואנו
      נעשה כל מאמץ למצוא פתרון מתאים ולטפל בפנייה בהקדם האפשרי. כדי שנוכל לטפל
      בבעיה בדרך הטובה ביותר, אנחנו ממליצים מאוד לצרף פרטים מלאים ככל האפשר:
    </p>
    <ul>
      <li>תיאור הבעיה</li>
      <li>מהי הפעולה שניסיתם לבצע?</li>
      <li>באיזה דף גלשתם?</li>
      <li>סוג וגרסה של הדפדפן</li>
      <li>מערכת הפעלה</li>
      <li>סוג הטכנולוגיה המסייעת (במידה והשתמשתם)</li>
    </ul>

    <h3>פרטי התקשרות</h3>
    <ul>
      <li>שם העסק: קבוצת החינוך אנקורי</li>
      <li>כתובת: עזה 13 תל אביב</li>
    </ul>

    <h4>פרטי רכזת נגישות לתיאום פגישה נגישה ומידע נוסף:</h4>
    <ul>
      <li>שם רכז/ת הנגישות: שגב ליבוביץ</li>
      <li>
        טלפון: <a href="tel:03-6800100">03-6800100</a>
      </li>
      <li>
        מייל: <a href="mailto:segev_l@ankori.co.il">segev_l@ankori.co.il</a>
      </li>
    </ul>

    <h3>פרסום התאמות נגישות, הסדרי נגישות מבנים</h3>
    <p>להלן הסדרי הנגישות הקיימים בבית העסק / משרד:</p>

    <h4>חניה / כניסה</h4>
    <ul>
      <li>אין חניית נכים בקרבת העסק</li>
      <li>אין רמפה בכניסה לעסק</li>
      <li>אין סף קטן בדלת הכניסה של העסק</li>
      <li>רוחב הדלת בכניסה לעסק הינו 3 מ'</li>
      <li>ניתן להיכנס לעסק / לבניין עם כלב נחייה או שירות</li>
    </ul>

    <h4>לובי הבניין ומעליות</h4>
    <ul>
      <li>יש דלפק קבלה מאויש בלובי הבניין</li>
      <li>אין עזרים מסוג "לולאת השראה" ללקויי שמיעה בדלפק</li>
      <li>אין פס מוביל לאנשים עם מוגבלות בראיה אל דלפק המודיעין ואל המעליות</li>
      <li>אין בבניין מעלית מותאמת לאנשים עם מוגבלויות</li>
      <li>אין קריאת מס' הקומה במעלית</li>
      <li>אין כתב ברייל במעלית</li>
      <li>קיימות עמדות נגישות לקבלת שירות</li>
    </ul>

    <h4>שירותים</h4>
    <ul>
      <li>קיימים שירותי נכים נגישים בעסק / בלובי הבניין</li>
      <li>קיימים שלטי זיהוי והכוונה לשירותים</li>
      <li>השירותים ממוקמים בקומת העסק</li>
    </ul>

    <h4>אזור המתנה</h4>
    <ul>
      <li>יש מטבחון נגיש</li>
      <li>יש אזור המתנה עם כיסא מותאם</li>
    </ul>

    <p>
      לכל צורך ו/או מידע נוסף, אנא פנו לאיש הקשר או רכז הנגישות לפי פרטי
      ההתקשרות המפורטים לעיל או לנציג במקום.
    </p>
  </>
);

const Footer: React.FC = memo(() => {
  const [isAccessibilityOpen, setIsAccessibilityOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!isAccessibilityOpen) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsAccessibilityOpen(false);
    };

    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isAccessibilityOpen]);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top border line */}
        <div className="footer-border"></div>
        
        {/* Footer content */}
        <div className="footer-content">
          {/* Text links on the right */}
          <div className="footer-text-links">
            <a 
              href="https://ankori.co.il/" 
              className="footer-text-link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              קבוצת החינוך אנקורי
            </a>
            <a 
              href="https://ankori.co.il/%d7%a1%d7%98%d7%95%d7%93%d7%99%d7%95-%d7%90%d7%a0%d7%a7%d7%95%d7%a8%d7%99/" 
              className="footer-text-link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              סטודיו אנקורי
            </a>
          </div>
          
          {/* Social media icons on the left */}
          <div className="footer-social-icons">
            <a
              href="https://www.facebook.com/Ankori.school"
              className="footer-social-icon"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://usnhxnxfrynwiplufpcv.supabase.co/storage/v1/object/public/general_settings/images/1860508_facebook_social%20media_icon.svg"
                alt="Facebook"
                width="24"
                height="24"
              />
            </a>
            <a
              href="https://www.instagram.com/ankori_moments/"
              className="footer-social-icon"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://usnhxnxfrynwiplufpcv.supabase.co/storage/v1/object/public/general_settings/images/1860506_instagram_social%20media_icon.svg"
                alt="Instagram"
                width="24"
                height="24"
              />
            </a>
            <a
              href="https://www.youtube.com/user/AnkoriVideo"
              className="footer-social-icon"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://usnhxnxfrynwiplufpcv.supabase.co/storage/v1/object/public/general_settings/images/1860490_youtube_social%20media_icon.svg"
                alt="YouTube"
                width="24"
                height="24"
              />
            </a>
          </div>
        </div>
        
        {/* Black line below footer */}
        <div className="footer-bottom-border"></div>
        
        {/* Copyright text */}
        <div className="footer-copyright">
          ©2026 - כל הזכויות שמורות לאנקורי
          <span className="footer-copyright-separator">|</span>
          <button
            type="button"
            className="footer-accessibility-link"
            onClick={() => setIsAccessibilityOpen(true)}
          >
            הצהרת נגישות
          </button>
          <div className="footer-credit">
            <span>פותח על ידי </span>
            <a
              href="https://www.anicca-ai.com"
              className="footer-credit-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Anicca AI
            </a>
            <img
              src="/anicca-ai-logo.png"
              alt="Anicca AI"
              className="footer-credit-logo"
            />
          </div>
        </div>
      </div>

      {isAccessibilityOpen && (
        <div
          className="accessibility-modal-overlay"
          onClick={() => setIsAccessibilityOpen(false)}
        >
          <div
            className="accessibility-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="accessibility-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="accessibility-modal-close"
              aria-label="סגירת הצהרת הנגישות"
              onClick={() => setIsAccessibilityOpen(false)}
            >
              ×
            </button>
            <AccessibilityStatement />
          </div>
        </div>
      )}
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;